import gql from 'graphql-tag';

export const GET_NEW_TOKEN = gql`
  mutation getNewToken($token: String!) {
    getNewToken(token: $token)
  }
`;
